import { createFileRoute } from '@tanstack/react-router'
import { useUsersByWorkshop } from '@/api/hooks/useUsersByWorkshop'
import UserSettings from '@/components/organisms/user-settings'
import { useSetSidebarSubLabel } from '@/contexts/sidebar-sub-label-context'
import { useMyWorkshops } from '@/hooks/useMyWorkshops'

export const Route = createFileRoute('/_authenticated/users/$userId')({
  component: UserSettingsRoute,
})

function UserSettingsRoute() {
  const { userId } = Route.useParams()
  const { selectedWorkshopId } = useMyWorkshops()
  const { data: users = [] } = useUsersByWorkshop(selectedWorkshopId)
  const user = users.find(u => u.id === userId)

  useSetSidebarSubLabel(`/users/${userId}`, user?.email)

  if (!user) return null

  return <UserSettings key={user.id} user={user} workshopId={selectedWorkshopId} />
}
